<template>
  <v-container id="report-list">
    <app-city-header :payload="payload"> </app-city-header>

    <v-row>
      <v-col>Relatórios</v-col>
      <v-col class="text-right">
        <v-btn
          v-if="
            isFullAdmin || (groupsConfig.novoRelatorio && config.novoRelatorio)
          "
          outlined
          color="primary"
          class="ml-3"
          :to="'/cidade/' + payload.municipioId + '/relatorio/inserir'"
        >
          Novo Relatório
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload.relatorios"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item="props">
            <tr
              :class="{
                evidenciada:
                  props.item.statusRelatorioId === 2 ||
                  props.item.statusRelatorioId === 4,
                evidenciar: props.item.statusRelatorioId === 3,
                rejeitada:
                  props.item.statusRelatorioId === 1 ||
                  props.item.statusRelatorioId === 0
              }"
            >
              <td>
                <a
                  :href="
                    './#/cidade/' +
                      props.item.municipioId +
                      '/relatorio/obter/' +
                      props.item.relatorioId
                  "
                  >{{ props.item.titulo }}</a
                >
              </td>
              <td>{{ props.item.usuario.nome }}</td>
              <td>
                {{ props.item.criacao | moment("DD/MM/YYYY") }}
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <span>
              Nenhum relatório retornado
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AppCityHeader } from "@/modules/city";
import { reportAPI } from "@/modules/report";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AppCityHeader
  },
  data() {
    return {
      headers: [
        { text: "Título", value: "titulo" },
        { text: "Criado por", value: "usuario.nome" },
        { text: "Criado em", value: "criacao" }
      ],
      payload: {
        municipioId: this.$route.params.id,
        relatorios: []
      },
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig"))
    };
  },
  methods: {
    ...mapActions([
      "setLoading",
      "setConsultorCondutorMunicipio",
      "setConsultorEspecialistaMunicipio",
      "setAnalistaMunicipio",
      "setADMunicipio"
    ]),
    getReports() {
      this.setLoading(true);
      reportAPI
        .getByCity(this.payload.municipioId)
        .then(resp => {
          this.payload.relatorios = resp.data;
          this.setLoading(false);
        })
        .catch(resp => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter relatórios");
        });
    }
  },
  computed: {
    ...mapGetters([
      "loading",
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "isAnalista",
      "isSPFesp",
      "isSPFespEspecial",
      "isSPCoordenador",
      "isFullAdmin"
    ])
  },
  mounted() {
    this.getReports();
    this.setConsultorCondutorMunicipio(this.$route.params.id);
    this.setConsultorEspecialistaMunicipio(this.$route.params.id);
    this.setAnalistaMunicipio(this.$route.params.id);
    this.setADMunicipio(this.$route.params.id);
  }
};
</script>
